import React, { Component } from 'react'
import { Col, Container, Row, Nav, NavItem, NavLink } from 'reactstrap'
import { observer, inject } from 'mobx-react'
import DataWrapper from '../../principal/containers/DataWrapper'
import classnames from 'classnames';
import MeuTeconStore from '../stores/MeuTeconStore';
import Dashboard from '../components/Dashboard';
import Notificacoes from '../components/Notificacoes';
import ModalDados from '../components/ModalDados';
import { BigPicture } from '../../bigpicture/telas/BigPicture';
import {AtualizacaoCadastral } from '../../atualizacaocadastral/telas/AtualizacaoCadastral';

@inject("store")
@DataWrapper
@observer
export default class MeuTecon extends Component {

    constructor(props) {
        super(props);

        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
        this.controller = new MeuTeconStore();

        this.renderContent = this.renderContent.bind(this);
        this.renderModalItem = this.renderModalItem.bind(this);
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Meu Tecon");
    }

    renderContent() {
        switch(this.controller.abaAtiva) {
            case 'dash':
                return <Dashboard controller={this.controller} />
            case 'notif':
                return (
                    <Notificacoes controller={this.controller} />
                );
            case 'bigPic':
                return (
                    <BigPicture />
                );
            case 'atuacadastral':
            return (
                <AtualizacaoCadastral/>
            );
            default:
                null
        }
    }

    renderModalItem() {
        return this.controller.modalItem && <ModalDados controller={this.controller} />
    }

    render() {
        return (
            <div className="form-wrapper">
                {this.renderModalItem()}
                <Container fluid>
                    <Row>
                        <Nav tabs className="pb-3" style={{maxWidth:'none'}}>
                            <NavItem>
                                <NavLink style={{fontSize:"12px"}} className={classnames({active: this.controller.abaAtiva === 'dash'})} onClick={() => this.controller.mudarAba('dash')} >
                                    Dashboard
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink style={{fontSize:"12px"}} className={classnames({active: this.controller.abaAtiva === 'notif'})} onClick={() => this.controller.mudarAba('notif')} >
                                    Notificações
                                </NavLink>
                            </NavItem>
                            {!process.env.rig && <NavItem>
                                <NavLink style={{fontSize:"12px"}} className={classnames({active: this.controller.abaAtiva === 'bigPic'})} onClick={() => this.controller.mudarAba('bigPic')} >
                                    Big Picture
                                </NavLink>
                            </NavItem>}
                            {!process.env.rig && <NavItem>
                                <NavLink style={{fontSize:"12px"}} className={classnames({active: this.controller.abaAtiva === 'atuacadastral'})} onClick={() => this.controller.mudarAba('atuacadastral')} >
                                    Atualização Cadastral
                                </NavLink>
                            </NavItem>
                            }
                        </Nav>
                    </Row>
                    {
                        this.renderContent()
                    }
                </Container>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/meutecon/telas/MeuTecon.js